import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import accountSettings from './translations/account-settings'
import { actionCard } from './translations/action-card'
import { activityPage } from './translations/activity-page'
import { allOpportunitiesPage } from './translations/all-opportunities-page'
import { auth } from './translations/auth'
import { causeAwarenessDates } from './translations/cause-awareness-dates'
import { causes } from './translations/causes'
import { createOpportunityPage } from './translations/create-opportunity-page'
import { common } from './translations/common'
import { companyActivityCard } from './translations/company-activity-card'
import { companySettings } from './translations/company-settings'
import { ctaButtons } from './translations/cta-buttons'
import { employeesPage } from './translations/employees-page'
import { employeeOpportunityPage } from './translations/employee-opportunity-page'
import { footer } from './translations/footer'
import { formFields } from './translations/form-fields'
import { imageGalleryPage } from './translations/image-gallery-page'
import { impactCard } from './translations/impact-card'
import { impactPage } from './translations/impact-page'
import { landingPageForCompanies } from './translations/landing-page-for-companies'
import { landingPageForNonprofits } from './translations/landing-page-for-nonprofits'
import { nav } from './translations/nav'
import { nonprofitApp } from './translations/nonprofit-app'
import { noticeBanner } from './translations/notice-banner'
import { onboardingPage } from './translations/onboarding-page'
import { opportunityRequestModal } from './translations/opportunity-request-modal'
import { opportunityRequestsPage } from './translations/opportunity-requests-page'
import { pollingForm } from './translations/polling-form'
import { referralPage } from './translations/referral-page'
import { resourcesPage } from './translations/resources-page'
import { rsvpPage } from './translations/rsvp-page'
import { typeaheads } from './translations/typeaheads'
import { volunteerActivityPage } from './translations/volunteer-activity-page'
import { marketplacePage } from './translations/marketplace-page'
import { table } from './translations/table'
import * as utils from './translations/utility-functions'

const i18nUtils = {
  causeTranslator: (causeString) => {
    return utils.causeTranslator(causeString)
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    resources: {
      en: {
        translation: {
          ...accountSettings.en,
          ...actionCard.en,
          ...activityPage.en,
          ...allOpportunitiesPage.en,
          ...auth.en,
          ...causeAwarenessDates.en,
          ...causes.en,
          ...createOpportunityPage.en,
          ...common.en,
          ...companyActivityCard.en,
          ...companySettings.en,
          ...ctaButtons.en,
          ...employeesPage.en,
          ...employeeOpportunityPage.en,
          ...footer.en,
          ...formFields.en,
          ...landingPageForCompanies.en,
          ...landingPageForNonprofits.en,
          ...imageGalleryPage.en,
          ...impactCard.en,
          ...impactPage.en,
          ...marketplacePage.en,
          ...nav.en,
          ...nonprofitApp.en,
          ...noticeBanner.en,
          ...onboardingPage.en,
          ...opportunityRequestModal.en,
          ...opportunityRequestsPage.en,
          ...pollingForm.en,
          ...referralPage.en,
          ...resourcesPage.en,
          ...rsvpPage.en,
          ...table.en,
          ...typeaheads.en,
          ...volunteerActivityPage.en,
        },
      },
      fr: {
        translation: {
          ...accountSettings.fr,
          ...actionCard.fr,
          ...activityPage.fr,
          ...allOpportunitiesPage.fr,
          ...auth.fr,
          ...causeAwarenessDates.fr,
          ...causes.fr,
          ...createOpportunityPage.fr,
          ...common.fr,
          ...companyActivityCard.fr,
          ...companySettings.fr,
          ...ctaButtons.fr,
          ...employeesPage.fr,
          ...employeeOpportunityPage.fr,
          ...footer.fr,
          ...formFields.fr,
          ...landingPageForCompanies.fr,
          ...landingPageForNonprofits.fr,
          ...imageGalleryPage.fr,
          ...impactCard.fr,
          ...impactPage.fr,
          ...marketplacePage.fr,
          ...nav.fr,
          ...nonprofitApp.fr,
          ...noticeBanner.fr,
          ...onboardingPage.fr,
          ...opportunityRequestModal.fr,
          ...opportunityRequestsPage.fr,
          ...pollingForm.fr,
          ...referralPage.fr,
          ...resourcesPage.fr,
          ...rsvpPage.fr,
          ...table.fr,
          ...typeaheads.fr,
          ...volunteerActivityPage.fr,
        },
      },

    },
    interpolation: {
      escapeValue: false, // React already protects from XSS
    },
  })

Object.assign(i18n, { utils: i18nUtils })

export default i18n
